// extracted by mini-css-extract-plugin
export default {"container":"Qeiq","header":"AZNp","instructionsWrapper":"VbDp","errorsWrapper":"iEHS","error":"FeiP"};